export default __webpack_public_path__ + "static/media/new-logo.d140a1ef.svg";